import { actionEndpoints } from './actionTriggerConfigs'
import { fetchEndpoints } from './fetchDataConfigs'
import { UserSerializer } from './userSerializer'

export const endpoints = {
  user: UserSerializer.endpoints,
  ...fetchEndpoints,
  ...actionEndpoints,
}
